import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed, onMounted, ref, watch } from "vue";
import JwtService from "@/core/services/JwtService";
import blankImage from "@/assets/media/folder/blank-image.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthImage',
  props: {
    imageGuid: { default: "" },
    side: { default: "client" },
    size: { default: "40px" }
  },
  setup(__props: any) {

const props = __props;



const urlValid = ref(true);

const processUrl = async () => {
  if (props.imageGuid === "-1") return blankImage;
  let img_src = "";
  // console.log("props.url: ", props.url);
  if (props.imageGuid === "no-image") img_src = "/images/no-image.png";
  else if (
    props.imageGuid === null ||
    props.imageGuid === "" ||
    props.imageGuid === "no-avatar"
  ) {
    img_src = "/images/avatar.png";
  } else if (/^https:\/\//.test(props.imageGuid)) {
    img_src = props.imageGuid;
  } else {
    img_src =
      window["api"] +
      "/api/v1/" +
      (props.side ? (props.side as string) : "tenant") +
      "/media/" +
      props.imageGuid +
      "?access_token=" +
      JwtService.getToken();
  }
  urlValid.value = await isImageSrcValid(img_src);
  return urlValid.value ? img_src : blankImage;
};

const src = ref("");
watch(
  () => props.imageGuid,
  async () => {
    src.value = await processUrl();
  }
);

onMounted(async () => {
  src.value = await processUrl();
});

function isImageSrcValid(src: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;

    img.onload = () => {
      resolve(true); // Valid image URL
    };

    img.onerror = () => {
      resolve(false); // Invalid image URL
    };
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: src.value,
    style: _normalizeStyle({
      width: _ctx.size,
      height: _ctx.size,
    }),
    alt: ""
  }, null, 12, _hoisted_1))
}
}

})